export const MCP_SERVER_URL = 'https://api.vectormethods.com/mcp';
export const MCP_SERVER_NAME = 'videovector';

export type McpAgentId = 'claude' | 'codex' | 'chatgpt' | 'cursor' | 'vscode' | 'other';

export interface McpConnection {
  id: McpAgentId;
  label: string;
  snippetLabel: string;
  snippet: string;
  instruction: string;
  guideUrl?: string;
  action?: { label: string; href: string };
}

const remoteServer = { url: MCP_SERVER_URL };

export const CURSOR_MCP_INSTALL_URL = `cursor://anysphere.cursor-deeplink/mcp/install?name=${MCP_SERVER_NAME}&config=${encodeURIComponent(btoa(JSON.stringify(remoteServer)))}`;

export const MCP_CONNECTIONS: readonly McpConnection[] = [
  {
    id: 'claude',
    label: 'Claude',
    snippetLabel: 'Server URL',
    snippet: MCP_SERVER_URL,
    instruction: 'In Claude, open Customize → Connectors → Add custom connector and paste this URL.',
    guideUrl: 'https://support.claude.com/en/articles/11175166-get-started-with-custom-connectors-using-remote-mcp',
  },
  {
    id: 'codex',
    label: 'Codex',
    snippetLabel: 'Terminal command',
    snippet: `codex mcp add ${MCP_SERVER_NAME} --url ${MCP_SERVER_URL}`,
    instruction: 'Run this command in your terminal.',
    guideUrl: 'https://developers.openai.com/codex/mcp',
  },
  {
    id: 'chatgpt',
    label: 'ChatGPT',
    snippetLabel: 'Server URL',
    snippet: MCP_SERVER_URL,
    instruction: 'Enable Developer mode, then add this URL in Plugins → +.',
    guideUrl: 'https://developers.openai.com/plugins/quickstart',
  },
  {
    id: 'cursor',
    label: 'Cursor',
    snippetLabel: '~/.cursor/mcp.json',
    snippet: JSON.stringify({ mcpServers: { [MCP_SERVER_NAME]: remoteServer } }, null, 2),
    instruction: 'Add to your Cursor configuration, or open it directly below.',
    guideUrl: 'https://cursor.com/docs/mcp',
    action: { label: 'Add to Cursor', href: CURSOR_MCP_INSTALL_URL },
  },
  {
    id: 'vscode',
    label: 'VS Code',
    snippetLabel: '.vscode/mcp.json',
    snippet: JSON.stringify({ servers: { [MCP_SERVER_NAME]: { type: 'http', ...remoteServer } } }, null, 2),
    instruction: 'Add to .vscode/mcp.json in your project.',
    guideUrl: 'https://code.visualstudio.com/docs/agent-customization/mcp-servers',
  },
  {
    id: 'other',
    label: 'Other',
    snippetLabel: 'Server URL · Streamable HTTP',
    snippet: MCP_SERVER_URL,
    instruction: 'Add this URL as a remote MCP server in your agent.',
  },
];
